import createLeafletComponent from './createLeafletComponent';
export { default as Map } from './Map';
export { default as useMapInstance } from './utils/useMapInstance';
export { default as useMapEvents } from './utils/useMapEvents';
export { default as useEvents } from './utils/useEvents';
export { createLeafletComponent };
export const Marker = createLeafletComponent('marker');
export const TileLayer = createLeafletComponent('tileLayer');
export const LayerGroup = createLeafletComponent('layerGroup');
export const ImageOverlay = createLeafletComponent('imageOverlay');
export const ToolTip = createLeafletComponent('tooltip');
export const Popup = createLeafletComponent('popup');
export const Rectangle = createLeafletComponent('rectangle');
export const Circle = createLeafletComponent('circleMarker');
export const CircleMarker = createLeafletComponent('circle');
export const GeoJSON = createLeafletComponent('geoJSON');
//# sourceMappingURL=index.js.map